export default function Breadcrumbs(theme) {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        root: {
          '& .MuiBreadcrumbs-separator': {
            margin: theme.spacing(0, 1),
            color: theme.palette.text.secondary,
          },
          '& .MuiBreadcrumbs-li': {
            '&:last-child': {
              color: theme.palette.text.primary,
              fontWeight: 500,
            },
          },
        },
        ol: {
          flexWrap: 'wrap',
        },
      },
    },
  };
}

